import { Link } from "react-router-dom";
import sgold from "../images/SwissGold-Transparent.png";
import coinmarket from "../images/CoinMarketCap.svg";
import coinGecoke from "../images/coingecko-logo-freelogovectors.svg";

const Footer = () => {
  return (
    <footer className="bg-gray-900/5 text-gray-200 p-5 flex-col md:flex-row flex flex-wrap justify-center md:justify-between items-center border-[1px] border-yellow-400 rounded-t-3xl">
      <div className="flex w-full md:w-[500px] justify-center my-5 mt-5 md:my-0">
        <img src={sgold} alt="Swiss Gold" width={"245px"} />
        <div className="hidden md:flex items-start justify-center ml-2 flex-col ">
          <h1 className="text-yellow-400 font-bold text-3xl">SwissGold</h1>
          <p className=" text-sm mt-2 ">
            SwissGold is the most modern way of gold investing. You can use your
            $SWCH yokens and receive $SGOLD tokens. Our advanced trading bots
            trade with your assets and make profit for you. SwissGold is the
            most modern way of gold investing.
          </p>
        </div>
      </div>
      <div className="h-[1px] block md:hidden w-full bg-gradient-to-r from-black via-gray-600 to-black"></div>
      <div className="flex justify-center my-5 md:my-0 mt-5 mx-4">
        <div className="flex flex-col ">
          <Link className="hover:text-yellow-400 my-3 mx-1">Home</Link>
          <Link className="hover:text-yellow-400 my-3 mx-1">Invest</Link>
          <Link className="hover:text-yellow-400 my-3 mx-1">
            Terms&Conditions
          </Link>
          <Link className="hover:text-yellow-400 my-3 mx-1">Blog</Link>
        </div>
        <div className="flex flex-col ">
          <Link className="hover:text-yellow-400 my-3 mx-1">Swap Gold</Link>
          <Link className="hover:text-yellow-400 my-3 mx-1">Staking</Link>
          <Link className="hover:text-yellow-400 my-3 mx-1">
            Provacy Policy
          </Link>
        </div>
      </div>
      <div className="h-[1px] block md:hidden w-full  bg-gradient-to-r from-black via-gray-600 to-black"></div>
      <div className="flex flex-col items-center my-5 mt-5 mx-4 md:my-0">
        <div className="flex">
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/4138/4138126.png"
              alt="Twitter"
            />
          </Link>
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/2111/2111646.png"
              alt="Telegram"
            />
          </Link>
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/15713/15713420.png"
              alt="Instagram"
            />
          </Link>
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/1384/1384060.png"
              alt="Youtube"
            />
          </Link>
        </div>
        <div className="flex">
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/5968/5968756.png"
              alt="Discord"
            />
          </Link>
          <Link>
            <img className="w-[28px] m-2" src={coinmarket} alt="Coin Market" />
          </Link>
          <Link>
            <img className="w-[28px] m-2" src={coinGecoke} alt="Instagram" />
          </Link>
          <Link>
            <img
              className="w-[28px] m-2"
              src="https://cdn-icons-png.flaticon.com/128/10096/10096702.png"
              alt="Github"
            />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
